<script lang="ts">
    import { _ } from 'svelte-i18n';

    import IconDoNotDisturbOn from './IconDoNotDisturbOn.svelte';
    import WarningColor from '../WarningColor.svelte';
    import { Job } from '../../components/Jobs/Job';

    export let job: Job | null = null;

    let infoRejectedBy = '';

    if (job !== null) {
        infoRejectedBy = job.getRejectedAssignments().join(', ');
    }
</script>

<WarningColor>
    <IconDoNotDisturbOn scale={0.5} title={$_('Rejected')} on:click />
</WarningColor>
